const Footer = () => (
  <footer>
    <span>&copy; {new Date().getFullYear()} MRO</span>
  </footer>
);

export default Footer;
